import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const InformativosContext = createContext();

export const useInformativos = () => {
  const context = useContext(InformativosContext);
  if (!context) {
    throw new Error('useInformativos must be used within an InformativosProvider');
  }
  return context;
};

export const InformativosProvider = ({ children }) => {
  const [unviewedCount, setUnviewedCount] = useState(0);
  const [lastUpdate, setLastUpdate] = useState(Date.now());

  const fetchUnviewedCount = async () => {
    try {
      const res = await api.get('/informativos/unviewed');
      setUnviewedCount(res.data.informativos.length);
      setLastUpdate(Date.now());
    } catch (err) {
      console.error('Erro ao buscar contagem de não vistos:', err);
    }
  };

  const markAsViewed = async (informativoId) => {
    console.log('📌 Marcando como visto:', informativoId);
    try {
      // Chama a API para marcar como visto
      await api.post(`/informativos/${informativoId}/view`);
      console.log('✅ API chamada com sucesso para marcar como visto');
      // Busca novamente para sincronizar o contador
      await fetchUnviewedCount();
      console.log('✅ Contador atualizado após marcar como visto');
    } catch (error) {
      console.error('❌ Erro ao marcar como visto:', error);
      throw error; // Re-throw para que o componente possa lidar com o erro
    }
  };

  const unmarkAsViewed = async (informativoId) => {
    console.log('📌 Desmarcando como visto:', informativoId);
    try {
      // Chama a API para desmarcar como visto
      await api.delete(`/informativos/${informativoId}/view`);
      console.log('✅ API chamada com sucesso para desmarcar como visto');
      // Busca novamente para sincronizar o contador
      await fetchUnviewedCount();
      console.log('✅ Contador atualizado após desmarcar como visto');
    } catch (error) {
      console.error('❌ Erro ao desmarcar como visto:', error);
      throw error; // Re-throw para que o componente possa lidar com o erro
    }
  };

  useEffect(() => {
    fetchUnviewedCount();
    // Atualiza a cada 30 segundos
    const interval = setInterval(fetchUnviewedCount, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <InformativosContext.Provider value={{
      unviewedCount,
      fetchUnviewedCount,
      markAsViewed,
      unmarkAsViewed,
      lastUpdate
    }}>
      {children}
    </InformativosContext.Provider>
  );
};